import RecurringProphyStudy from './studyConfig/RecurringProphyStudy'

export default new RecurringProphyStudy({
  molecule: 'Magnesium',
  smallText: 'e.g. Magnesium Oxide tablets',
  dosageOptions: [
    '200mg per day',
    '400mg per day'
  ]
})



// WEBPACK FOOTER //
// ./src/store/recurring/recurringProphyMagnesium.js